import { EDealType, EEntityType } from '../../shared/repositories/favorites/entities/add_favorite/AddFavoriteEntityPublicRequestSchema';
import { fetchDeleteOfferFromFavorites } from '../../shared/repositories/favorites/v1/delete-offer-from-favorites';
export async function removeFavorites(_ref) {
  let {
    httpApi,
    logger,
    params
  } = _ref;
  const parameters = {
    dealType: EDealType.Sale,
    entityType: EEntityType.OfferResidental,
    entityId: params.offerId
  };
  try {
    await fetchDeleteOfferFromFavorites({
      httpApi,
      parameters
    });
  } catch (error) {
    logger.error(error, {
      offerId: params.offerId,
      domain: 'removeFavorite'
    });
    return false;
  }
  return true;
}